<template>
  <b-nav vertical>
    <b-nav-item to="/private/status" v-show="hasCustomerPermissions">Status</b-nav-item>
    <b-nav-item to="/private/myprofile" v-show="hasCustomerPermissions">{{$t('privatePage.my_profile_header')}}</b-nav-item>
    <b-nav-item to="/private/expertreports" v-show="hasSupplierPermissions">{{($t('privatePage.expert_report_header'))}}</b-nav-item>
    <b-nav-item to="/private/testsuite" v-show="hasCustomerPermissions">{{$t('privatePage.testsuite_header')}}</b-nav-item>
    <b-nav-item to="/private/usergroups" v-show="hasResellerPermissions">{{$t('privatePage.usergroups_header')}}</b-nav-item>
    <b-nav-item to="/private/testmethods" v-show="hasSupplierPermissions">{{$t('privatePage.testmethods_header')}}</b-nav-item>
    <b-nav-item to="/private/my-testmethods" v-show="hasCustomerPermissions && !hasSupplierPermissions">{{$t('privatePage.my_testmethods_header')}}</b-nav-item>
    <b-nav-item to="/private/scales" v-show="hasSupplierPermissions">{{$t('privatePage.scales_header')}}</b-nav-item>
    <b-nav-item to="/private/instructions" v-show="hasSupplierPermissions">{{$t('privatePage.instructions_header')}}</b-nav-item>
    <b-nav-item to="/private/normgroups" v-show="hasSupplierPermissions">{{$t('privatePage.normgroups_header')}}</b-nav-item>
    <b-nav-item to="/private/testdata" v-show="hasSupplierPermissions">{{$t('privatePage.testdata_header')}}</b-nav-item>
  </b-nav>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'sidebar-menu',
  computed: {
    ...mapGetters([
      'hasSupplierPermissions',
      'hasResellerPermissions',
      'hasCustomerPermissions'
    ])
  }
}
</script>

<style scoped>
.navItemLvl2 {
  margin-left: 20px;
}
</style>
